import type { InternalPermission } from 'src/constants/internal-access/internalPermissions'
import type { InternalIdentity } from 'src/interfaces/internalAuth'

/**
 * `/v1/internal/auth/me` expands an `allPermissions` role into the full list, so a plain
 * membership check is correct for every role, admin and super_admin included.
 */
export const hasPermission = (
  identity: InternalIdentity | null,
  permission: InternalPermission,
): boolean => {
  if (!identity) {
    return false
  }

  return identity.permissions.includes(permission)
}
